import Axios from "axios";

export const AutoleieAPI = {
    async getInsurances(userId) {
        try {
            const result = await Axios.get(`autoleie/insurance/${userId}`);
            if (result.status != "200") throw new Error(result);
            return result.data;
        } catch (err) {
            console.error(err);
            throw err;
        }
    },
    async getReservation(id) {
        try
        {
            const result = await Axios.get(`autoleie/reservations/${id}`);
            if (result.status != "200") throw new Error(result);
            return result.data;
        } catch (err) {
            console.error(err);
            return {};
        }
    },
    async getCustomers(stationId) {
        try
        {
            const result = await Axios.get(`autoleie/customers/${stationId}`);
            if (result.status != "200") throw new Error(result);
            return result.data;
        } catch (err) {
            console.error(err);
            return {};
        }
    },
    /**
     * need update to work with startdate and enddate
     * 
     * @param {*} stationId 
     * @returns 
     */
    async getCars(stationId) {
        try
        {
            const result = await Axios.get(`autoleie/cars/${stationId}`);
            if (result.status != "200") throw new Error(result);
            return result.data;
        } catch (err) {
            console.error(err);
            return {};
        }
    },
    async getContacts(customerId) {
        try
        {
            const result = await Axios.get(`autoleie/contacts/${customerId}`);
            if (result.status != "200") throw new Error(result);
            return result.data;
        } catch (err) {
            console.error(err);
            return {};
        }
    },
    async saveReservation(id, reservation) {
        try {
            console.log("Saving reservation", reservation);
            const result = await Axios.patch(`autoleie/reservations/${id}`, JSON.stringify(reservation));
            if (result.status != "200") throw new Error(result);
            return result.data;
        } catch (err) {
            console.error(err);
            return {};
        }
    },
    async getLocationInfo(id) {
        try {
            const result = await Axios.get(`autoleie/locations/${id}`);
            if (result.status != "200") throw new Error(result);
            return result.data;
        } catch (err) {
            console.error(err);
            return {};
        }
    },
    async getPriceUpdate(priceUpdateRequest) {
        try {
            console.log("Updating price", priceUpdateRequest);
            const result = await Axios.post(`autoleie/priceUpdate`,JSON.stringify(priceUpdateRequest));
            if (result.status != "200") throw new Error(result);
            return result.data;
        } catch (err) {
            console.error(err);
            return {};
        }
    },
    async postCreateNewDriver(customerId, newDriver) {
        try {
            console.log("Creating new driver", newDriver);
            const result = await Axios.post(`autoleie/contacts/${customerId}`, JSON.stringify(newDriver));
            if (result.status != "200") throw new Error(result);
            return result.data;
        } catch (err) {
            console.error(err);
            return {};
        }
    },
    async patchEditDriver(customerId, driverId, editedDriver) {
        try {
            console.log("Editing  driver", editedDriver);
            const result = await Axios.patch(`autoleie/contacts/${customerId}/${driverId}`, JSON.stringify(editedDriver));
            if (result.status != "200") throw new Error(result);
            return result.data;
        } catch (err) {
            console.error(err);
            return {};
        }
    },
    async postNewBooking(newBooking) {
        try {
            console.log("Creating new booking", newBooking);
            const result = await Axios.post(`autoleie/reservations`, JSON.stringify(newBooking));
            if (result.status != "200") throw new Error(result);
            return result.data;
        } catch (err) {
            console.error(err);
            return {};
        }
    },
};
